import React from 'react';
import HomeBody from '../HomeBody/HomeBody';
import Particles from 'react-particles-js';
import { makeStyles } from '@material-ui/core/styles';

// CSS Style
const useStyles = makeStyles((theme) => ({
    particle: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 55,
        bottom: 0,
        opacity: 0.4
      

    },
}));

const Home = () => {
    const classes = useStyles();
    return (
        <>
            <HomeBody />
            <Particles className={classes.particle}
                params={{
                    particles: {
                        number: {
                            value: 30,
                            density:true,
                            value_area:900
                        },
                        shape:{
                            type: 'circle',
                            strole:{
                                width:1,
                                color: "tomato",
                            }
                        },
                        size: {
                            value:8,
                            random:true,
                            anim:{ enable:false, speed:10, size_min:0.1, sync:false}
                        },
                        opacity:{
                            value:1 ,
                            random:true,
                            anim:{enable:true, speed:1, opacity_min:0.1, sync:true}
                        }
                    }
                }}
            />
          
            
          



        </>
    );
};

export default Home;